import { render, staticRenderFns } from "./CardProjection.vue?vue&type=template&id=68951542&scoped=true&"
import script from "./CardProjection.vue?vue&type=script&lang=js&"
export * from "./CardProjection.vue?vue&type=script&lang=js&"
import style0 from "./CardProjection.vue?vue&type=style&index=0&id=68951542&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68951542",
  null
  
)

export default component.exports